import { render } from "./DataListNewActions.vue?vue&type=template&id=7cea8fd0"
import script from "./DataListNewActions.vue?vue&type=script&lang=js"
export * from "./DataListNewActions.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Pages/DataListNewActions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7cea8fd0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7cea8fd0', __exports__)) {
    console.log('reload')
    api.reload('7cea8fd0', __exports__)
  }
  
  module.hot.accept("./DataListNewActions.vue?vue&type=template&id=7cea8fd0", () => {
    console.log('re-render')
    api.rerender('7cea8fd0', render)
  })

}


export default __exports__